import { Component } from 'react';
import type { Readonly } from '../../common/util';
type Props = {
  id: string;
};

export class ChartComponent extends Component<Props> {
  shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<{}>, nextContext: any): boolean {
    return false;
  }

  render() {
    return <div id={this.props.id} style={{ width: '100%' }} />;
  }
}
